import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';

const LoadingLayerProvider = () => {
  const { loading } = useContext(PageContext);

  return (
    <>
      <Outlet />
      {/* Invisible on purpose: the control that started the request shows its progress, and a
          dim over a visible form reads as a slower, separate wait. This only stops a second
          action elsewhere on the page meanwhile; unlike `inert`, it leaves focus where it was. */}
      {loading && (
        <div aria-hidden data-slot="request-lock" className="fixed inset-0 z-50 cursor-progress" />
      )}
    </>
  );
};

export default LoadingLayerProvider;
